// VENDORED from andavo-dev:
//   libs/client/web/shared/platform/common/src/ProviderComposer/WebProviderComposer.tsx
// Only the `buildProvidersTree` reducer (the composer PATTERN) is vendored.
// andavo-dev's concrete `WebProvidersTree` is wired to Auth0 + Datadog + nuqs;
// experts-web assembles its own lean provider set in src/app/providers.tsx using
// this composer. At merge, the lean set is replaced by the real WebProvidersTree
// and the Entra→Auth0 swap stays a one-file change (see src/auth/).
import type React from 'react';

type ProvidersType = [React.ElementType, Record<string, unknown>?];
type ChildrenType = {
  children: React.ReactNode;
};

/**
 * Compose an ordered list of provider components into a single nesting tree.
 * Earlier entries wrap later ones (outermost first).
 */
export const buildProvidersTree = (providers: Array<ProvidersType>) => {
  const initialProvider = ({ children }: ChildrenType) => children;
  return providers.reduce(
    (
      AccumulatedProviders: React.ElementType,
      [Provider, props = {}]: ProvidersType,
    ) => {
      return ({ children }: ChildrenType) => {
        return (
          <AccumulatedProviders>
            <Provider {...props}>{children}</Provider>
          </AccumulatedProviders>
        );
      };
    },
    initialProvider,
  );
};
